export default function getProgressBarColor  (percentage) {
    if (percentage < 30) return "bg-green-500";
    if (percentage < 60) return "bg-yellow-500";
    return "bg-red-500";
};